export function parseWidgetGameDisplay(gameName: string): { title: string; format: string | null } {
  const trimmed = gameName.trim()
  const formatMatch = trimmed.match(/(\d+\s*\/\s*\d+)\s*$/)
  if (!formatMatch) {
    return { title: trimmed, format: null }
  }
  return {
    title: trimmed.slice(0, formatMatch.index).trim(),
    format: formatMatch[1].replace(/\s/g, ''),
  }
}

export type WidgetGameDisplayLines = {
  /** Game name (without trailing draw format when parsed). */
  title: string
  /** Draw format on row 2 (e.g. 6/49); null when not parsed. */
  format: string | null
}

/** Two-row widget header: row1 = name, row2 = format (never a third wrapped line). */
export function getWidgetGameDisplayLines(gameName: string): WidgetGameDisplayLines {
  return parseWidgetGameDisplay(gameName)
}

function hashGameSlug(gameSlug: string): number {
  let hash = 0
  for (let i = 0; i < gameSlug.length; i += 1) {
    hash = (hash * 31 + gameSlug.charCodeAt(i)) >>> 0
  }
  return hash
}

/** Decorative ball / badge digits for widget cards (not draw data). */
export function getWidgetCardDecor(gameSlug: string): {
  ballDigit: number
  badgeDigit: number
  alternate: boolean
} {
  const hash = hashGameSlug(gameSlug || 'game')
  return {
    ballDigit: (hash % 9) + 1,
    badgeDigit: ((hash >>> 4) % 9) + 1,
    alternate: hash % 5 === 2,
  }
}

